import Vue from 'vue';

export default {
  changed(state, {
    value,
    type,
    key,
    label,
  }) {
    state.items = {
      ...state.items,
      [key]: {
        type,
        label,
        value,
      },
    };
  },

  setFacet(state, { key, value }) {
    if (!state.facets[key]) {
      Vue.set(state.facets, key, value);

      return;
    }

    Vue.delete(state.facets, key);
    Vue.set(state.facets, key, value);
  },

  removeFacet(state, key) {
    Vue.delete(state.facets, key);
  },
};
